<template>
  <div
    class="c-product-info-mobile-drawer"
    :class="[
      'l-container',
      { 'c-product-info-mobile-drawer--active-selection': bundleProduct }
    ]"
  >
    <!--
      engraving modal is below the selection modal
      the selection view inside product grid could be more mobile friendly
    -->
    <product-grid
      :products="products"
      :bundle="product"
      :bundle-product="bundleProduct"
      :filtered="filtered"
      :active-options="activeOptions"
      :compact="true"
      :max-products="25"
      :irregular-prices="irregularPrices"
      :bundle-slot-count="bundleSlotCount"
      :is-mobile="true"
      @update:selection="addToBundle"
      @update:bundleProduct="handleBundleProduct"
      @engraving="$emit('engraving', $event)"
    />
  </div>
</template>

<script>
import BundleStateMixin from './BundleStateMixin'
import FiltersMixin from './FiltersMixin'
import get from 'lodash/get'
import GlobalDrawerRefMixin from './GlobalDrawerRefMixin'
import ProductGrid from '../productGrid/ProductGrid'

export default {
  components: {
    ProductGrid,
  },
  mixins: [
    FiltersMixin,
    BundleStateMixin,
    GlobalDrawerRefMixin,
  ],
  props: {
    product: {
      type: Object,
      required: true
    },
    price: {
      type: [Number, String],
      default: ""
    },
    products: {
      type: Array,
      required: true
    },
    filtered: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelection(event) {
      this.$emit("update:selection", event);
    },
    originalPrice(index) {
      let result;
      const irregularPrices = this.irregularPrices;
      const bundle = this.product;
      const product = this.activeOptions[index].product;
      const bundleSlotCount = this.bundleSlotCount;
      if (bundle && irregularPrices) {
        //console.warn('[Product Card]: Ring prices irregular - displaying variant compare at price')
        result = get(product, "variants[0].compareAtPrice");
      } else {
        result = get(bundle || product, "variants[0].compareAtPrice");
      }
      if (!result && process.env.NODE_ENV === "debug") {
        console.warn("[Product Card]: Invalid or missing original price!");
      }
      if (bundle && !irregularPrices) {
        result = String((+result / bundleSlotCount).toFixed(2));
      }
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-product-info-mobile-drawer {
  grid-auto-rows: 1fr; /* equal height rows */
  &--active-selection .c-product-grid::v-deep {
    padding-top: 0;
    padding-bottom: 0;
  }
  &__title {
    margin-bottom: 0;
    flex: 1;
    padding-right: rem(5px);
  }
  &__selection {
    min-height: rem(300px);
    /* makes the grid items fill equal-height rows, many are over
       300px anyway */
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: rem(10px) 0;
    &--new {
      margin-left: rem(30px);
    }
    &__action {
      color: rgb(0, 193, 193);
      button {
        border: 0px;
        @include themify($themes) {
          background-color: themed("background", "base");
        }
      }
    }
  }
  &__image {
    width: rem(180px);
    height: rem(180px);
    margin: auto;
    &--default {
      width: 65%;
      height: 80%;
    }
  }
  &__dropdown {
    width: 100%;
  }
}
</style>
